import React from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import PivotTable from "../../table/PivotTable";

const ChangeByMethodTable = props => (
  <PivotTable
    titles={[
      {
        key: "items",
        title: "",
        columnSpan: 1
      },
      {
        key: "years",
        title: "",
        columnSpan: 3,
        majorGroup: true,
        groupEnd: true
      },
      {
        key: "2020-2025",
        title: "5-yr change<br />(2020 to 2025)",
        columnSpan: 2,
        groupEnd: true
      },
      {
        key: "2025-2030",
        title: "5-yr change<br />(2025 to 2030)",
        columnSpan: 2,
        majorGroup: true,
        groupEnd: true
      },
      {
        key: "2020-2030",
        title: "10-yr change<br />(2020 to 2030)",
        columnSpan: 2
      }
    ].slice(0, props.show10YearChange ? undefined : -1)}
    columnKey="year"
    columnDefinitions={[
      {
        value: "2020"
      },
      {
        value: "2025"
      },
      {
        value: "2030",
        majorGroup: true,
        groupEnd: true
      },
      {
        value: "# (2020-2025)",
        label: "#"
      },
      {
        value: "% (2020-2025)",
        label: "%",
        percentage: true,
        groupEnd: true
      },
      {
        value: "# (2025-2030)",
        label: "#"
      },
      {
        value: "% (2025-2030)",
        label: "%",
        percentage: true,
        majorGroup: true,
        groupEnd: true
      },
      {
        value: "# (2020-2030)",
        label: "#"
      },
      {
        value: "% (2020-2030)",
        label: "%",
        percentage: true
      }
    ].slice(0, props.show10YearChange ? undefined : -2)}
    rowKey="method"
    rowDefinitions={[
      ...methods.map(method => ({
        value: method
      })),
      {
        value: "Total",
        total: true
      }
    ].slice(0, props.showTotals ? undefined : -1)}
    data={props.data}
  />
);

ChangeByMethodTable.propTypes = {
  data: PropTypes.array.isRequired,
  show10YearChange: PropTypes.bool,
  showTotals: PropTypes.bool
};

ChangeByMethodTable.defaultProps = {
  showTotals: true
};

export default ChangeByMethodTable;
